<route>
{
    "name": "vehicles-index",
    "meta": {
        "title": "Autovehicule",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "birou", "service"],
        "fail": "/404"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col>
                    <index></index>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import Index from 'Components/vehicles/Index'

    export default {
        components: {
            CompanyLayout,
            Index
        }
    };
</script>
